<template>
  <div
    class="ks-overlay ks-static ks-static-news"
    ref="scrollContainer"
    v-on:scroll.passive="$root.measure($event, $refs.scrollTarget)"
  >
    <div class="ks-overlay-hitarea" v-on:mouseover="$root.hitareaActive = true" v-on:mouseout="$root.hitareaActive = false"  v-on:click="$router.push({name:'home'})"/>
    <div class="ks-overlay-container" ref="scrollTarget" :class="{'ks-overlay-container-top': $root.scrollOffset === false}">
      <Closetag v-bind:force="'home'" v-bind:hasnav="true"/>
      <div class="ks-overlay-container-stickyhead ks-static-nav">
          <div class="ks-overlay-container-stickyhead-wrapper">
            <a
            class="ks-round-button ks-round-button-zoom"
            :class="{'ks-round-button-active': mode === 'actual'}"
            v-on:click="jump('actual')"
            >
                <span>Aktuell</span>
            </a>
            <a
            class="ks-round-button ks-round-button-zoom"
            :class="{'ks-round-button-active': mode === 'past'}"
            v-on:click="jump('past')"
            >
                <span>Archiv</span>
            </a>
          </div>
      </div>
      <div class="ks-static-entry">

        <div class="ks-overlay-container-head">
        <h1>News</h1>
        </div>

        <div class="ks-roundbox" v-if="project.Text">
            <div class="ks-overlay-container-small">
                <div class="ks-static-news-title" :class="{'ks-static-news-title-top': !(project.DatumDarstellen[0] == 'Tag/Monat/Jahr HH:MM' || project.DatumDarstellen[0] == 'Tag/Monat/Jahr')}">
                    <p class="ks-static-news-title-left" v-if="project.DatumDarstellen[0] == 'Tag/Monat/Jahr HH:MM' || project.DatumDarstellen[0] == 'Tag/Monat/Jahr'">
                    {{project.Datum | yearformat('Tag/Monat/Jahr')}}
                    </p>
                    <p class="ks-static-news-title-right" v-if="project.DatumDarstellen[0] == 'Tag/Monat/Jahr HH:MM'">
                    {{project.Datum | yearformat('HH:MM')}} Uhr
                    </p>
                    <h1>
                        {{project.Icon[0]}}
                        <span v-html="project.Titel"/>
                    </h1>
                </div>
            </div>
        <div class="ks-overlay-container-small ks-overlay-container-lined" v-html="project.Text"/>
        <div class="ks-news-container-small" v-if="project.Link[0] || project.Link[1]">
            <div class="ks-blue-button-wrapper">
                <a class="ks-blue-button ks-blue-button-autoheight" v-if="project.Link[0]" :href="project.Link[0]" target="_blank"><span>{{project.Link[0]}}</span></a>
                <a class="ks-blue-button ks-blue-button-autoheight" v-if="project.Link[1]" :href="`mailto:${project.Link[1]}`" target="_blank"><span>{{project.Link[1]}}</span></a>
            </div>
        </div>
        <div class="ks-overlay-container-inset"  v-if="project.Downloads && project.Downloads.length > 0">
            <a class="bigdownload" v-for="(file, filekey) in project.Downloads" target="_blank" :href="file.Original" v-bind:key="`download-${filekey}`">
                <div>
                <img :src="file.Resized[0]"/>
                </div>
                <span v-html="file.Captions[0]"/>
            </a>
        </div>
        </div>
            <template v-if="(project.Bilder && project.Bilder.length > 0) || (project.Video && project.Video.length > 0)">
            <div class="ks-flipcard ks-flipcard-notext">
                <swiper ref="mySwiper" :options="flipOptions">
                <swiper-slide  v-for="(i,ik) in project.Bilder" v-bind:key="ik">
                    <img :src="i.Resized[2]"/>
                </swiper-slide>
                <template v-if="project.Video && project.Video.length > 0">
                    <swiper-slide class="video" v-for="(i, ik) in project.Video" v-bind:key="`v-i${ik}`" v-html="i[0]"/>
                </template>
                <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            </template>
      </div>
      <div class="ks-static-entry ks-static-news-more" v-if="more">
            <router-link :to="{name: 'news', params: {id: m._id, stub: m._name}}" v-if="m._id != project._id"  class="ks-static-news-more-entry" v-for="m in more" v-bind:key="`m-${m._id}`">
                <div class="ks-static-news-title"  :class="{'ks-static-news-title-top': !(m.DatumDarstellen[0] == 'Tag/Monat/Jahr HH:MM' || m.DatumDarstellen[0] == 'Tag/Monat/Jahr')}">
                    <p class="ks-static-news-title-left" v-if="m.DatumDarstellen[0] == 'Tag/Monat/Jahr HH:MM' || m.DatumDarstellen[0] == 'Tag/Monat/Jahr'">
                    {{m.Datum | yearformat('Tag/Monat/Jahr')}}
                    </p>
                    <p class="ks-static-news-title-right" v-if="m.DatumDarstellen[0] == 'Tag/Monat/Jahr HH:MM'">
                    {{m.Datum | yearformat('HH:MM')}} Uhr
                    </p>
                    <h1>
                        {{m.Icon[0]}}
                        <span v-html="m.Titel"/>
                    </h1>
                    <div class="ks-static-news-title-body" v-html="m.Lead"/>
                </div>
            </router-link>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable */

import Closetag     from '../components/Closetag.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import Footer       from '../components/Footer.vue'
import 'swiper/css/swiper.css'

export default {
    name: 'News',
    components: {
        Closetag,
        Swiper,
        SwiperSlide,
        Footer
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    watch:{
        $route (to, from){
            if(to.name === 'news') {
                this.init(true);
                /*
                this.$root.scrollOffset = false
				this.$root.transitioning = true;
                setTimeout(() => {
					this.project = this.more = false;
					this.init()
                    this.$scrollTo(this.$refs.scrollTarget, 0, {
                        container: this.$refs.scrollContainer,
                        lazy: false,
                        offset: 0,
                        force: true,
                        cancelable: true,
                        x: false,
                        y: true
                    })
                    setTimeout(()=>{
						this.$root.transitioning = false;
                    },300)
                },250)*/
            }
        }
    },
    data () {
        let _self = this;
        return {
            project: false,
            more: false,
            caption: 0,
            mode: 'actual',
            flipOptions: {
                effect: 'flip',
                grabCursor: true,
                flipEffect: {
                    rotate: 230,
                    slideShadows: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                watchOverflow: true,
                autoHeight: true
            }
        }
    },
    mounted() {
        this.init();
    },
    beforeRouteLeave (to, from, next) {
		console.log('leave');
		if (to.name !== 'new') {
			this.$root.scrollOffset = false;
			this.$root.$emit('overlay:close', true);
			this.$root.applyMeta();
		}
		next();
    },    
    methods: {
        jump(mode) {
            this.mode = mode;
            this.$route.params.id = null;
            this.init(true);
        },
        init(noscroll) {
			console.log('init')
            this.$http(`/news${this.$route.params.id ? '/' : ''}${this.$route.params.id || ""}?mode=${this.mode}`).then((d) => {
                if (this.$route.params.id || this.mode === 'actual') {
                    this.project = d.data
                    this.project.DatumDarstellen = this.project.DatumDarstellen || []
                    this.project.Icon = this.project.Icon || []
                    if (this.project.Meta) {
                        this.$root.applyMeta(
                            `Kulturstiftung Thurgau${this.project.Icon[0] ? ` ${this.project.Icon[0]} ` : ' ⚡️ '}${this.project.Meta[0]}`,
                            this.project.Meta[1] || "",
                            this.project.Meta[2] || "",
                            this.project.Bilder && this.project.Bilder.length ? this.project.Bilder[0].Resized[2] : false
                        )
                    }
                } else {
                    this.project = false
                }
                this.$nextTick(()=>{
                    if (this.$root.scrollOffset === true || noscroll == true) {
                        var options = {
                            container: this.$refs.scrollContainer,
                            easing: noscroll === true ? 'ease-out' : [0.34, 1.56, 0.64, 1],
                            lazy: false,
                            offset: noscroll === true ? 0 : document.documentElement.clientHeight * -.5,
                            force: true,
                            cancelable: true,
                            x: false,
                            y: true
                        }
                        this.$scrollTo(this.$refs.scrollTarget, 350, options)
                    }
                    this.$root.overlayOpen   = true;        
                })
                this.more = d.data.more                
                this.more.forEach(m => {
                    m.DatumDarstellen = m.DatumDarstellen || []
                    m.Icon = m.Icon || []
                })
                
                //this.$http(`/contributions/7/10?data=Icon|Titel|Lead`).then((m) => {
                //    this.more = m.data
                //});
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

    @import '../main';

    .ks-static {
        &-news {
			.ks-roundbox {
                padding-top: 0;
            }
            .ks-overlay-container-gallery {
                background: $ks-blue;
                color: white;
            }
            .ks-overlay-container-small {
                background: transparent;
            }
            .ks-overlay-container {
                color: $ks-blue;
            }
            .ks-overlay-container-dark,
            .ks-overlay-container-head,
            .ks-overlay-container-stickyhead {
                background: transparent;
            }
            .ks-round-button {
                span {
                color: $ks-blue;
                }
                background: white;
                border-color: $ks-blue;
                color: $ks-blue;
                &-active {
                background: $ks-blue;
                border-color: $ks-blue;
                span {
                    color: white;
                }
                }
            }
            .bigdownload {
                span {
                color: $ks-blue;
                }
            }
            .ks-flipcard {
                & .swiper-pagination-bullet {
                    background: $ks-blue;
                }
                &-text {
                    background: $ks-blue;
                    color: white;
                }
            }
            &-more {
                margin-bottom: var(--pd4);                
                &-entry {
                    margin-top: var(--pd4);
                    @extend .ks-roundbox;
                    padding-bottom: var(--pd2);            
                    display: block;
                    background: $ks-blue;
                    color: white;
                    @media (hover: hover) {
                        transition: all 0.25s;
                        &:hover {
                            transform: scale(1.02);
                            box-shadow: 3px 3px 7px 2px rgba(0,0,0,0.5);
                        }
                    }
                    & > div {
                        div p {
                            @include mediumfont();
                        }
                        @include sm() {
                            padding: var(--pd05);
                        }
                    }                    
                }
            }
            &-title {
                position: relative;
                padding-top: var(--pd1);
                margin: auto;
                &-left,
                &-right {
                    position: absolute;
                    top: var(--pd2);
                    padding: 0;                
                }
                &-left {
                    left: 0;
                }
                &-right {
                    right: 0;
                }
                &-body {
                    p {
                        padding: 0;
                    }
                }
                h1 {
                    text-align: center;
                    padding: var(--pd3) 0 0 0;
                    p {
                        padding: 0;
                        margin-top: var(--pd1);
                        @include largefont();                        
                    }
                }
                &-top {
                    h1 {
                        padding: var(--pd1) 0 0 0;
                    }
                }
            }
        }
    }



</style>



// WEBPACK FOOTER //
// src/components/News.vue